import { render } from "./WaitlistTitleBar.vue?vue&type=template&id=2b78383e&scoped=true"
import script from "./WaitlistTitleBar.vue?vue&type=script&lang=js"
export * from "./WaitlistTitleBar.vue?vue&type=script&lang=js"

import "./WaitlistTitleBar.vue?vue&type=style&index=0&id=2b78383e&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b78383e"]])

export default __exports__